import { render, staticRenderFns } from "./EmployeeScreens.vue?vue&type=template&id=163a0b30&scoped=true&"
import script from "./EmployeeScreens.vue?vue&type=script&lang=js&"
export * from "./EmployeeScreens.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeScreens.vue?vue&type=style&index=0&id=163a0b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163a0b30",
  null
  
)

export default component.exports